export enum AmazonLexLanguage {
    'English (US)' = 'en-US',
    
    // Apparently, we can't use these 2 languages
    // 'English (UK)' = 'en-UK',
    // 'German' = 'de-DE'
}